export const baseUrl = process.env.VUE_APP_ROOT;
export const baseUrlApi = process.env.VUE_APP_ROOT_API;
export const base_url_seances = process.env.VUE_APP_ROOT_SEANCES;